import { z } from "zod";

// ============ TIPOS DE PAGINAÇÃO ============
export type paginationResponseType = {
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
};

export type Pagination = paginationResponseType & {
    order?: 'asc' | 'desc';
    orderBy?: string;
    totalPages: number;
};

// ============ SCHEMAS ZOD ============
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(50).default(10)
});

export const orderSchema = z.object({
    order: z.enum(['asc', 'desc']).default('desc'),
    orderBy: z.string().default('createdAt')
});

export const statusFilterSchema = z.object({
    status: z.enum(['pending', 'approved', 'rejected', 'flagged']).optional(),
});

export const userTypeFilterSchema = z.object({
    userType: z.enum(['admin', 'client', 'seller', 'accountant', 'inactive', 'canceled']).optional(),
});

export const paginatedOrderSchema = z.object({
    ...paginationSchema.shape,
    ...orderSchema.shape,
});

export const commentSearchSchema = z.object({
    ...paginatedOrderSchema.shape,
    ...statusFilterSchema.shape,
});

export const userSearchSchema = z.object({
    ...paginatedOrderSchema.shape,
    ...userTypeFilterSchema.shape,
});

// ============ TIPOS DE PARÂMETROS ============
export type PaginationParams = z.infer<typeof paginationSchema>;
export type OrderParams = z.infer<typeof orderSchema>;
export type PaginatedOrderParams = z.infer<typeof paginatedOrderSchema>;
export type StatusFilterParams = z.infer<typeof statusFilterSchema>['status'];
export type UserTypeFilterParams = z.infer<typeof userTypeFilterSchema>['userType'];
export type CommentSearchParams = z.infer<typeof commentSearchSchema>;
export type UserSearchParams = z.infer<typeof userSearchSchema>;

// ============ PROPS DE PÁGINAS ============
export type PageProps = {
    params: Promise<{
        id: string;
    }>;
};

export type PageAccountantClientsProps = {
    params: Promise<{
        accountantId: string;
    }>;
};

export type PageSellerClientsProps = {
    params: Promise<{
        sellerId: string;
    }>;
};

// ============ TIPOS DE RESPOSTA PAGINADA ============
export type PaginatedResponse<T> = {
    data: T[];
    pagination: paginationResponseType;
};

// ============ TIPOS PARA FILTROS ============
export type SearchParams = {
    page?: number;
    perPage?: number;
    order?: 'asc' | 'desc';
    orderBy?: string;
    [key: string]: string | number | boolean | undefined;
};